// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1_2H9","label":"Section_label__3TSod","contentWrap":"Section_contentWrap__2PHb0","footer":"Section_footer__2RP42","footerInner":"Section_footerInner__3qciG"};